import { extendTailwindMerge } from 'tailwind-merge';

const tailwindMergeConfig = {
  prefix: 'tw-',
};

const twMerge = extendTailwindMerge(tailwindMergeConfig);

export default twMerge;
